import { useEffect } from "react";
import { Router } from "./Router";
import { useAuthStore } from "./stores/authStore";

function App() {
  const initialize = useAuthStore((state) => state.initialize);

  // 초기 세션 로드
  useEffect(() => {
    initialize();
  }, [initialize]);

  return <Router />;
}

export default App;
